import ActionType from '../action-types';

const initialState = {
  loading: false,
  error: null,
  success: false,
  staffs: null,
  page: 1,
  perPage: 20,
  total: 0,
  searchResults: null,
  searchResultsTotal: 0,
  searchResultsLoading: false,
  searchResultsError: null,
  searchResultsPage: 1,
  searchResultsPerPage: 20,
  staffView: 'normal'
};

// eslint-disable-next-line default-param-last
const staffsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.FETCH_STAFFS_START:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
        staffs: null,
        page: action.payload.page
      };
    case ActionType.FETCH_STAFFS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: true,
        staffs: action.payload.staffs,
        total: action.payload.total,
        perPage: action.payload.per_page
      };
    case ActionType.FETCH_STAFFS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
        staffs: null,
        page: 1,
        total: 0
      };
    case ActionType.STAFF_SEARCH_START:
      return {
        ...state,
        searchResultsLoading: true,
        searchResultsError: null,
        searchResults: null,
        searchResultsPage: action.payload.page
      };
    case ActionType.STAFF_SEARCH_SUCCESS:
      return {
        ...state,
        searchResultsLoading: false,
        searchResultsError: null,
        searchResults: action.payload.searchResults,
        searchResultsTotal: action.payload.total,
        searchResultsPerPage: action.payload.per_page
      };
    case ActionType.STAFF_SEARCH_ERROR:
      return {
        ...state,
        searchResultsLoading: false,
        searchResultsError: action.payload,
        searchResults: null,
        searchResultsPage: 1,
        searchResultsTotal: 0
      };
    case ActionType.SET_STAFF_VIEW:
      return {
        ...state,
        staffView: action.payload.view
      };
    default:
      return state;
  }
};

export default staffsReducer;
